import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Logo from '../../../components/logo';
import Search from '@ifeng/ui_pc_search/';
import UserInfo from '@ifeng/ui_pc_userInfo/';

class Header extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    render() {
        const { content } = this.props;
        const { search } = content;
        const logoData = { logo: content.logo };
        /**
         * 组件分发数据
         */

        return (
            <div className={styles.header}>
                <div className={styles.header_bar}>
                    <Logo content={logoData} />
                    <div className={styles.box}>
                        <div className={styles.search}>
                            <Chip
                                id="10129"
                                type="static"
                                title="搜索"
                                groupName="头部"
                                translate="jsonParse"
                                content={search}>
                                <Search expand />
                            </Chip>
                        </div>
                        <div className={styles.user}>
                            <UserInfo iconShow option={['login']} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default errorBoundary(Header);
